function promotedEquipmentPoints(promotedEquipmentById, equipment) {
  const relatedPointIds = promotedEquipmentById[equipment.promoted_equipment_id]?.pointIds ?? [];
  return (equipment?.points ?? [])
    .filter((p) => Boolean(p.promoted_point_id))
    .filter((p) => relatedPointIds.includes(p.promoted_point_id));
}

export function equipmentPromotionStatus(promotedEquipmentById, equipment) {
  if (!equipment.promoted_equipment_id) {
    return { status: 'unpublished' };
  }
  const promotedPoints = promotedEquipmentPoints(promotedEquipmentById, equipment);
  const unpromotedPoints = equipment.points?.filter((p) => !promotedPoints.includes(p)) ?? [];
  if (unpromotedPoints.length === 0) {
    return { status: 'published' };
  }
  return { status: 'partial', unpromotedPoints };
}

export function hasUnpublishedChanges(equipment) {
  return equipment.promoted_equipment_id && equipment.last_promoted < equipment.modified;
}
